import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { TableSkeleton } from '@/components/ui/skeleton';

const BundlesPage = lazy(() => import('@/pages/bundles'));

export const Route = createFileRoute('/products/bundles')({
  component: function BundlesRoute() {
    return (
      <Suspense fallback={<TableSkeleton />}>
        <BundlesPage />
      </Suspense>
    );
  },
});
